module.exports = __webpack_public_path__ + "img/FreightRequirements.3a412e16.svg";